import React, { useState, useRef } from "react";
import { Button, Form, Checkbox, message } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import InputCard from "../../../../../Components/Cards/InputCard";
import { useLocation } from "react-router-dom";
import "./style.css";
import { createDriverDocumentRequirement } from "../../../../../API/Admin/SystemConfiguration/DriverDocuments";

const getErrorMessage = (data, fallback) => {
  if (!data) return fallback;
  if (data.message) return data.message;
  if (data.detail) return data.detail;

  const fieldErrors = Object.values(data)
    .flat()
    .filter((msg) => typeof msg === "string");

  return fieldErrors.length ? fieldErrors.join(" ") : fallback;
};

const AddDriverDocument = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    generalInformation: {},
    requirementLogic: {},
    allowedFormatInformation: {},
  });

  const handleBack = () => {
    navigate("/system-configuration", {
      state: {
        activeTab: location.state?.from || "Driver Document Required",
      },
    });
  };

  const generalInformationFields = [
    {
      name: "documentName",
      label: "Document Name",
      type: "text",
      placeholder: "Enter Document Name",
      rules: [{ required: true, message: "Document name is required" }],
    },
    {
      name: "Category",
      label: " Category",
      type: "select",
      placeholder: "Select Category",
      options: ["Legal", "Compliance", "Financial", "Operational", "General"],
      rules: [{ required: true, message: "Category is required" }],
    },
  ];

  const requirementLogicFields = [
    {
      name: "isRequired",
      label: "Required",
      description: "Marks this document as required when adding or editing a driver.",
      type: "switch",
      fullWidth: true,
    },
    {
      name: "hasExpiry",
      label: "Has Expiry Date",
      description: "This document type can have an expiry date tracked.",
      type: "switch",
      fullWidth: true,
    },
  ];
  const handleSubmit = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch (error) {
      message.error("Please fill in all required fields.");
      return;
    }

    setSaving(true);
    try {
      const res = await createDriverDocumentRequirement({
        document_name: values.documentName,
        category: (values.Category || "").toLowerCase(),
        is_required: !!values.isRequired,
        has_expiry: !!values.hasExpiry,
        allowed_formats: (values.allowedFormat || []).map((f) =>
          f.toLowerCase(),
        ),
        status: "active",
      });

      if (Math.floor(res?.status / 100) === 2) {
        message.success(
          res?.data?.message || "Driver document added successfully!",
        );
        navigate("/system-configuration", {
          state: {
            activeTab:
              location.state?.from || "Driver Document Required",
          },
        });
      } else {
        message.error(
          getErrorMessage(res?.data, "Failed to add document requirement."),
        );
      }
    } catch (err) {
      message.error(
        getErrorMessage(
          err?.response?.data,
          "Failed to add document requirement.",
        ),
      );
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();

    setFormData({
      generalInformation: {},
      requirementLogic: {},
      allowedFormatInformation: {},
    });
  };

  return (
    <div className="add-fleet">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
          Back
        </Button>
      </div>
      <div className="title">Add Document Requirement </div>
      <Form form={form} layout="vertical">
        <div className="input-cards-container">
          <InputCard
            title="General Information"
            fields={generalInformationFields}
            initialData={formData.generalInformation}
            onChange={(data) =>
              setFormData((prev) => ({ ...prev, generalInformation: data }))
            }
          />

          <InputCard
            title="Requirement Logic"
            fields={requirementLogicFields}
            initialData={formData.requirementLogic}
            onChange={(data) =>
              setFormData((prev) => ({
                ...prev,
                requirementLogic: data,
              }))
            }
          />

          <InputCard title="Allowed Formats">
            <Form.Item
              name="allowedFormat"
              label="Accepted File Type"
              rules={[
                { required: true, message: "Please select at least one format" },
              ]}
            >
              <Checkbox.Group
                options={[
                  { label: "PDF", value: "PDF" },
                  { label: "JPG", value: "JPG" },
                  { label: "PNG", value: "PNG" },
                ]}
              />
            </Form.Item>
          </InputCard>
        </div>

        <div className="btns-row">
          <Button onClick={handleCancel}>Cancel</Button>
          <Button
            type="primary"
            onClick={handleSubmit}
            className="save-btn"
            loading={saving}
            disabled={saving}
          >
            Add Driver Document
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default AddDriverDocument;
